<!-- product-customization-dialog.component.html -->

@if (product) {
<div class="p-4 max-h-[80vh] overflow-y-auto">
<h2 class="text-2xl font-bold text-primary mb-4">{{ product?.name }}</h2>
<div class="space-y-6">
@if (product.ingredients.length > 0) {
<div class="flex flex-col gap-3">
    <span class="title text-site text-[24px]">
      Composition: Décochez si un ingrédient ne vous convient pas 😋🤤
    </span>
  <div class="grid xl:grid-cols-2 gap-3">
    @for (ingredient of product.ingredients; track ingredient) {
    <label
      class="ingredient-card flex items-center justify-between px-[12px] bg-white border border-[#E7E7E7] label rounded-[6px]"
      [class.cursor-not-allowed]="ingredient.required"
      [class.cursor-pointer]="!ingredient.required">

      <div class="flex items-center space-x-3 flex-1 min-w-0">
        <mat-checkbox
          [checked]="selectedIngredients.includes(ingredient.id)"
          [disabled]="ingredient.required"
          (change)="onIngredientChange($event, ingredient.id)">
        </mat-checkbox>

        <div class="flex-1 min-w-0 flex items-center flex-wrap gap-2">
          <span class="text-base font-medium text-site">{{ ingredient.name }}</span>
              @if (ingredient.required) {
    <span class="bg-[#15803D] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] whitespace-nowrap">
                  Obligatoire
                </span>
    }
    </div>
  </div>

  @if (ingredient.image) {
    <img
      [ngSrc]="ingredient.image || 'assets/images/placeholders/placeholder.webp'"
      [alt]="ingredient.name || 'Image à venir'"
      width="60"
      height="60"
      loading="lazy"
      class="rounded-lg ml-3 object-cover">
    }
    </label>
    }
  </div>
</div>
}
@if (getFilteredAdditions().length >0) {
<h3 class="text-[24px] text-site title mb-0">
  Choisissez vos accompagnements 🍗🥦🧀️🥣🥤
</h3>
}
@for (addition of getFilteredAdditions(); track addition; let i = $index) {
<div
  class="addition-block"
  [attr.id]="'addition-' + i">
  <h3 class="text-[24px] text-site title mb-3 ">
    {{ getAdditionTitle(addition) }}
    <span class="text-[18px] font-normal text-gray-600">
              ({{ addition.required ? 'Obligatoire' : 'Optionnel' }}
      - {{ getTotalQuantityForAddition(addition.id) }}/{{ addition.quantity }} choix)
            </span>
  </h3>
  <div class="grid xl:grid-cols-2 gap-3">
    @for (item of addition.items; track item) {
    <div
      class=" relative flex items-center justify-between px-[12px] bg-white border border-[#E7E7E7] cursor-pointer label rounded-[6px]"
      [class.border-orange-500]="getItemQuantity(addition.id, item.id) > 0"
      [class.bg-orange-50]="getItemQuantity(addition.id, item.id) > 0"
      [class.opacity-60]="item.available === false"
      [class.cursor-not-allowed]="item.available === false"
      [class.cursor-pointer]="item.available === true">
      @if (item.available === false) {
    <span
      class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                    Non disponible
                  </span>
    }
    <div class="flex items-center space-x-3 flex-1">
      <div class="flex-1">
        <span class="text-[15px] text-site font-medium">{{ item.name }}</span>
                    @if (item.price) {
    <span class="text-sm text-site ml-2 whitespace-nowrap">(+{{item.price}} {{item.currency}})</span>
    }
    </div>
  </div>
  <div class="flex items-center mr-3">
    <button
      (click)="decrementItem(addition.id, item.id)"
      [disabled]="getItemQuantity(addition.id, item.id) === 0"
class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center
 hover:text-[#1a1a1a] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
      -
    </button>
    <span class="font-bold min-w-[20px] text-center">
    {{ getItemQuantity(addition.id, item.id) }}
    </span>
    <button
      (click)="incrementItem(addition.id, item.id, addition.quantity, i)"
      [disabled]="item.available === false"
class="w-8 h-8  cursor-pointer rounded-full border border-gray-300 flex items-center justify-center
 hover:text-[#1a1a1a] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
      +
    </button>
  </div>
  @if (item.image) {

    <img
      [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
      [alt]="item.name || 'Image à venir'"
      width="60"
      height="60"
      loading="lazy"
      class="rounded-lg ml-3">
    }
    </div>
    }
  </div>
</div>
}
@if (product.supplements.length > 0) {
<h3 class="text-[24px] text-[#FF730A] title mb-0">
  Ingrédients Supplémentaires 🍟🧀️🍗
</h3>
}
@for (category of getSupplementCategories(); track category) {
<div class="flex flex-col gap-3">
  <h2 class="text-[24px] text-site title mb-3 sticky">
    {{ category }}
    <span class="text-[18px] font-normal text-gray-600">(Optionnel)</span>
  </h2>
  <div class="grid xl:grid-cols-2 gap-3">
    @for (supplement of supplementsByCategory[category]; track supplement) {
    <label
      class="flex items-center justify-between px-[12px] bg-white border border-[#E7E7E7] cursor-pointer label rounded-[6px]"
      [class.border-orange-500]="isSupplementSelected(supplement.id)"
      [class.bg-orange-50]="isSupplementSelected(supplement.id)"
      >
      <div class="flex items-center space-x-3 flex-1">
        <mat-checkbox
          [checked]="isSupplementSelected(supplement.id)"
          (click)="$event.stopPropagation();toggleSupplement(supplement.id)">
        </mat-checkbox>
        <div class="flex-1">
          <span class="text-base text-site font-medium">{{ supplement.name }}</span>
                    <span class="text-sm text-site ml-2">
                      (+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }})
                    </span>
                  </div>
                </div>
                @if (supplement.image) {

    <img
      [ngSrc]="supplement.image || 'assets/images/placeholders/placeholder.webp'"
      [alt]="supplement.name || 'Image à venir'"
      width="60"
      height="60"
      loading="lazy"
      class="rounded-lg ml-3">
    }
    </label>
    }
  </div>
</div>
}
</div>
</div>
}
@if (product) {
<div class="px-4 pb-4 flex flex-col gap-2">
@if (getValidationMessage()) {
<div
  class="bg-orange-50 border border-orange-300 rounded-lg px-3 py-2 text-sm text-orange-700 font-medium text-center">
  ⚠️ {{ getValidationMessage() }}
</div>
}
<div class="flex justify-center items-center gap-4">
<button
[matButton]="themeConfig.appearance.button.cancel"
class="flex-1"
(click)="cancel()">
Annuler
</button>
<button
[matButton]="themeConfig.appearance.button.action"
class="flex-1"
[disabled]="!canAdd()"
(click)="confirm()">
Valider
</button>
</div>
</div>
}

